import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'availabilityPluralPipe'})

export class AvailabilityPluralPipe implements PipeTransform {

  transform(value: number): string {
    if(value === 1){
        return `${value} posto libero`
    }else if(value > 1){
        return `${value} posti liberi`
    }
      return ''
  }
}